// UPPDRAG-40 — read-only renderer for RichTextEditor output. Sanitizes
// the HTML via DOMPurify (sanitizeRichText) before passing to React via
// dangerouslySetInnerHTML. Returns null when the input is empty so the
// caller can short-circuit any wrapping card/border.

import { sanitizeRichText, isRichTextEmpty } from "@/lib/sanitizeHtml";
import { cn } from "@/lib/utils";

interface RichTextDisplayProps {
  html: string | null | undefined;
  className?: string;
}

export function RichTextDisplay({ html, className }: RichTextDisplayProps) {
  if (isRichTextEmpty(html)) return null;
  const safe = sanitizeRichText(html);
  return (
    <div
      className={cn(
        "prose prose-sm max-w-none",
        "prose-headings:font-semibold prose-h2:text-base prose-h3:text-sm",
        "prose-p:my-2 prose-ul:my-2 prose-ol:my-2 prose-blockquote:my-2",
        className,
      )}
      // Sanitized via DOMPurify in sanitizeRichText. See
      // src/test/lib/sanitizeHtml.test.ts for the XSS coverage that
      // pins what's stripped.
      dangerouslySetInnerHTML={{ __html: safe }}
    />
  );
}
